export default __webpack_public_path__ + "static/media/Location-icon.1455f0c2.svg";